// extracted by mini-css-extract-plugin
export default {"cls1":"AssignmentForm-Outputs-module--cls1--kfMqg","cls2":"AssignmentForm-Outputs-module--cls2--BXRr8 AssignmentForm-Outputs-module--cls1--kfMqg"};